import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import {
  ClearButton,
  DatePicker,
  EmptyState,
  Loading,
  PageTitle,
  RadioButton,
  SelectDropDown
} from 'components/common/Elements/Elements';
import CohortTable from './CohortTable/CohortTable';

import { getRequest, postRequest } from 'utils/requests';
import { createCohortData, createReqBody } from './helpers/helpers';

import { createFilterSize } from 'utils/common';

import classes from './CohortCollection.module.scss';

const CohortCollection = () => {
  const { t } = useTranslation(['activity']);
  const history = useHistory();

  //data from api
  const [cohortData, setCohortData] = useState({});
  const [cohortFilters, setCohortFilters] = useState([]);

  //filters
  const [date, setDate] = useState({ startDate: null, endDate: null });
  const [unit, setUnit] = useState(t('activity:units.PERCENT'));
  const [channel, setChannel] = useState([]);
  const [size, setSize] = useState([]);
  const [plan, setPlan] = useState([]);
  const [dataConection, setDataConection] = useState(false);
  const [filterConection, setFilterConection] = useState(false);
  const [trigerResetDatePicker, setTrigerResetDatePicker] = useState(false);

  //other data
  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);

  let cohortSize = [];

  const average = t('activity:cohorts.AVERAGE');
  const units = [t('activity:units.PERCENT'), t('activity:units.DOLLARS')];
  const numberОfFilters = 3;

  const handleDateChange = value => {
    setDate(value);
  };
  const handleUnit = e => {
    if (e.target.value !== unit) {
      setUnit(e.target.value);
    }
  };
  const handleChannel = e => {
    setChannel(e);
  };

  const handleSize = e => {
    setSize(e);
  };
  const handlePlan = e => {
    setPlan(e);
  };

  const resetAllfilters = () => {
    setUnit(t('activity:units.PERCENT'));
    setDate({
      startDate: null,
      endDate: null
    });
    setChannel([]);
    setSize([]);
    setPlan([]);
    setTrigerResetDatePicker(!trigerResetDatePicker);
  };

  useEffect(() => {
    let cancelled = false;
    getRequest('/cohorts/filters')
      .then(res => {
        if (!cancelled) {
          if (res.body) {
            setCohortFilters(res.body);
            setFilterConection(true);
          } else {
            setFilterConection(false);
          }
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setFilterConection(false);
        }
      });
    return () => (cancelled = true);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoaderTable(true);
    const linkForRequest = '/cohorts/collection';
    const REQ_BODY = createReqBody(channel, size, plan);

    postRequest(linkForRequest, REQ_BODY)
      .then(res => {
        if (!cancelled) {
          if (Object.keys(res.body).length) {
            setCohortData(res.body.data);
            setDataConection(true);
          } else {
            setDataConection(false);
          }
          setLoader(false);
          setLoaderTable(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setLoader(false);
          setLoaderTable(false);
          setDataConection(false);
          console.log(err);
        }
      });
    return () => (cancelled = true);
    // eslint-disable-next-line
  }, [channel, size, plan, history.location.search]);

  (function () {
    createFilterSize(cohortFilters.companySize, cohortSize);
  })();

  const cohortTable = createCohortData(cohortData, date, average);

  if (loader) {
    return <Loading />;
  }

  if (!dataConection || !filterConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <PageTitle title={t('activity:cohorts.COHORT_COLLECTION')} />
      <div className={classes.filters_wrap}>
        <div className={classes.filters}>
          <DatePicker
            label={t('activity:filters.DATE')}
            input={{
              value: date,
              onChange: handleDateChange
            }}
            position="bottom left"
            trigerResetDatePicker={trigerResetDatePicker}
          />
          <SelectDropDown
            options={cohortFilters.channel}
            input={{ value: channel, onChange: handleChannel }}
            label={t('activity:filters.CHANNEL')}
            multi
          />
          <SelectDropDown
            options={cohortFilters.plan}
            input={{ value: plan, onChange: handlePlan }}
            label={t('activity:filters.PRICING_PLAN')}
            multi
          />
          <SelectDropDown
            options={cohortSize}
            input={{ value: size, onChange: handleSize }}
            label={t('activity:filters.COMPANY_SIZE')}
            multi
            renderKey={'label'}
          />
          <div className={classes.input}>
            <RadioButton
              handleUnit={handleUnit}
              unit={unit}
              units={units}
              name={t('activity:units.UNIT')}
              title={t('activity:units.UNIT')}
              classTitle={classes.radio}
            />
          </div>
          <ClearButton
            onClick={() => resetAllfilters(true)}
            numberОfFilters={numberОfFilters}
          />
        </div>
      </div>
      <CohortTable tableData={cohortTable} loader={loaderTable} unit={unit} />
    </>
  );
};

export default CohortCollection;
